import React from 'react';
import { Badge } from 'components/badges';
import { formatDateToLocal, getDateTimePatterns } from 'utils/date';
import {
  NOTIFICATION_TYPE_BADGE_CLASSNAMES,
} from 'constants/notifications';
import { getNotificationTypeLabel } from 'utils/notifications';
import NotificationChannelIndicator from '../NotificationChannelIndicator/NotificationChannelIndicator';

export default function NotificationDropdownItem({ item, settings, onSelect }) {
  const { dateTimePattern } = getDateTimePatterns(settings);
  const createdDate = formatDateToLocal(item.createdAt, dateTimePattern);

  return (
    <li>
      <button
        type="button"
        onClick={() => onSelect?.(item)}
        className="w-full px-4 py-4 text-left transition hover:bg-white/5 cursor-pointer"
      >
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            {!item.isRead && (
              <span
                aria-hidden="true"
                className="size-2 shrink-0 rounded-full bg-indigo-400"
              />
            )}
            <p className="truncate text-sm font-semibold text-white">
              {item.title || getNotificationTypeLabel(item.type)}
            </p>
            <NotificationChannelIndicator channel={item.channel} className="shrink-0" />
            <Badge size="sm" className={NOTIFICATION_TYPE_BADGE_CLASSNAMES[item.type]}>
              {getNotificationTypeLabel(item.type)}
            </Badge>
          </div>

          <p className="mt-1 max-h-10 overflow-hidden text-sm leading-5 text-gray-400">
            {item.content || 'No message content.'}
          </p>
          <p className="mt-2 text-xs text-gray-500">
            <time dateTime={item.createdAt}>{createdDate}</time>
          </p>
        </div>
      </button>
    </li>
  );
}
